import {
  CUSTOM_ELEMENTS_SCHEMA,
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
} from '@angular/core';

import 'vidstack/player';
import 'vidstack/player/ui';
import 'vidstack/player/layouts/default';

export type VidstackMediaType = 'video' | 'audio';
export type VidstackPreload = 'none' | 'metadata' | 'auto';
type VidstackSource = string | { src: string; type: string };

@Component({
  selector: 'app-vidstack-player',
  imports: [],
  templateUrl: './vidstack-player.html',
  styleUrl: './vidstack-player.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VidstackPlayerComponent {
  readonly src = input.required<string>();
  readonly sourceType = input<string | null>(null);
  readonly mediaType = input.required<VidstackMediaType>();
  readonly title = input('');
  readonly poster = input<string | null>(null);
  readonly muted = input(false);
  readonly preload = input<VidstackPreload>('metadata');
  readonly playsInline = input(true);
  readonly interactive = input(true);

  readonly mediaSource = computed<VidstackSource>(() => {
    const src = this.src();
    const sourceType = this.resolveSourceType();

    if (!sourceType) {
      return src;
    }

    return {
      src,
      type: sourceType,
    };
  });

  private resolveSourceType(): string {
    const explicitType = (this.sourceType() ?? '').trim().toLowerCase();
    if (explicitType) {
      return explicitType;
    }

    return this.mediaType() === 'video' ? 'video/mp4' : 'audio/mpeg';
  }
}
